import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d535214"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "section-header" }
const _hoisted_5 = { class: "overline" }
const _hoisted_6 = { class: "overline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_OmsInstanceNavigator = _resolveComponent("OmsInstanceNavigator")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Settings")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, { lines: "full" }, {
                  default: _withCtx(() => [
                    (_ctx.userProfile?.partyImageUrl)
                      ? (_openBlock(), _createBlock(_component_ion_avatar, {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Image, {
                              src: _ctx.userProfile.partyImageUrl
                            }, null, 8, ["src"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_card_header, { class: "ion-no-padding ion-padding-vertical" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile.userLoginId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userProfile.partyName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  color: "danger",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logout()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Logout")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  fill: "outline",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLaunchpad()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("Go to Launchpad")) + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: _ctx.openOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('OMS')), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_OmsInstanceNavigator),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_subtitle, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Product Store")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Store")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('A store represents a company or a unique catalog of products. If your OMS is connected to multiple eCommerce stores selling different collections of products, you may have multiple Product Stores set up in HotWax Commerce.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Select store")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      placeholder: _ctx.$t('store name'),
                      value: _ctx.currentEComStore.productStoreId,
                      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setEComStore($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.userProfile ? _ctx.userProfile.stores : []), (store) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: store.productStoreId,
                            value: store.productStoreId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(store.storeName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Facility")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Specify which facility you want to operate from. Order, inventory and other configuration data will be specific to the facility you select.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Select facility")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      value: _ctx.currentFacility.facilityId,
                      onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFacility($event)))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.userProfile ? _ctx.userProfile.facilities : []), (facility) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: facility.facilityId,
                            value: facility.facilityId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(facility.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('App')) + " ", 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString("Version: " + _ctx.appVersion), 1)
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString("Built: " + _ctx.getDateTime(_ctx.appInfo.builtTime)), 1)
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Product Identifier')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Choosing a product identifier allows you to view products with your preferred identifiers.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Primary Product Identifier")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      placeholder: _ctx.$t('primary identifier'),
                      value: _ctx.productIdentificationPref.primaryId,
                      onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setProductIdentificationPref($event.detail.value, 'primaryId')))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productIdentifications, (identification) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: identification,
                            value: identification
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(identification), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Secondary Product Identifier")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select, {
                      interface: "popover",
                      placeholder: _ctx.$t('secondary identifier'),
                      value: _ctx.productIdentificationPref.secondaryId,
                      onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setProductIdentificationPref($event.detail.value, 'secondaryId')))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productIdentifications, (identification) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: identification,
                            value: identification
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(identification), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128)),
                        _createVNode(_component_ion_select_option, { value: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("None")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_card_header, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Timezone')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card_content, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('The timezone you select is used to ensure automations you schedule are always accurate to the time you select.')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_item, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userProfile && _ctx.userProfile.userTimeZone ? _ctx.userProfile.userTimeZone : '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeTimeZone())),
                      slot: "end",
                      fill: "outline",
                      color: "dark"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("Change")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}